/**
 * @fileoverview Arquivo responsável por centralizar constantes e catálogos do construtor de fluxos.
 */

import {
  MessageCircle, Bot, Globe, FileUp, Brain,
  SquareKanban, RefreshCw, ArrowRightLeft, Send, Mail, ShoppingBag, ClipboardCheck, Webhook,
} from "lucide-react";

/* ─── Node type registry ─────────────────────────────── */
var SIDEBAR_CATEGORIES = [
  {
    label: "Acionar",
    items: [
      { type: "receive_message", label: "Receber mensagem", icon: MessageCircle, color: "#22c55e", desc: "Quando uma mensagem chegar" },
      { type: "bulk_message", label: "Disparo em massa", icon: Send, color: "#6366f1", desc: "Envio em massa via API oficial" },
      // Integração Care: a OS mudou para um status escolhido → "Enviar Mensagem".
      { type: "order_status", label: "Status da OS", icon: Webhook, color: "#64748b", desc: "Quando uma OS do Care mudar de status" },
    ],
  },
  {
    label: "Acoes",
    items: [
      { type: "ai_agent", label: "Agente IA", icon: Bot, color: "#8b5cf6", desc: "Resposta inteligente com IA" },
      { type: "send_template", label: "Enviar Mensagem", icon: Mail, color: "#22c55e", desc: "Template de mensagem WhatsApp" },
      // Só aparece na barra lateral das empresas com a triagem por IA ligada.
      { type: "ai_triage", label: "Triagem IA", icon: ClipboardCheck, color: "#64748b", desc: "Checklist conduzido pela IA" },
    ],
  },
  {
    label: "Ferramentas Agente IA",
    items: [
      { type: "tool_websearch", label: "Web Search", icon: Globe, color: "#3b82f6", desc: "Pesquisar na internet" },
      { type: "tool_files", label: "Arquivos", icon: FileUp, color: "#f59e0b", desc: "Upload de arquivos para a IA" },
      { type: "tool_memory", label: "Memoria", icon: Brain, color: "#ec4899", desc: "Prompts organizados por casos" },
      { type: "tool_crm_create", label: "Criar Card CRM", icon: SquareKanban, color: "#10b981", desc: "Cria card no CRM com campos coletados" },
      { type: "tool_crm_update", label: "Atualizar Card", icon: RefreshCw, color: "#06b6d4", desc: "Atualiza campos do card existente" },
      { type: "tool_crm_status", label: "Status Card", icon: ArrowRightLeft, color: "#f97316", desc: "Move card entre colunas do CRM" },
      { type: "tool_woocommerce", label: "Produtos WooCommerce", icon: ShoppingBag, color: "#9333ea", desc: "Busca produtos no catalogo da loja" },
    ],
  },
];

// Types that are AI Agent tools (connect via tools handle)
var TOOL_TYPES = SIDEBAR_CATEGORIES
  .filter(function (cat) { return cat.label === "Ferramentas Agente IA"; })
  .reduce(function (acc, cat) { return acc.concat(cat.items.map(function (i) { return i.type; })); }, []);

// Flat list for node type lookup
var NODE_TYPES_CONFIG = SIDEBAR_CATEGORIES.reduce(function (acc, cat) {
  return acc.concat(cat.items);
}, []);

// Trigger types (only have output, no input)
var TRIGGER_TYPES = SIDEBAR_CATEGORIES
  .filter(function (cat) { return cat.label === "Acionar"; })
  .reduce(function (acc, cat) { return acc.concat(cat.items.map(function (i) { return i.type; })); }, []);

// Tool items for the popup menu
var TOOL_ITEMS = SIDEBAR_CATEGORIES
  .filter(function (cat) { return cat.label === "Ferramentas Agente IA"; })
  .reduce(function (acc, cat) { return acc.concat(cat.items); }, []);

var DEFAULT_NODES = [
  {
    id: "trigger-1",
    type: "flowNode",
    position: { x: 250, y: 60 },
    data: { label: "Receber mensagem", nodeType: "receive_message" },
  },
];

// Ícones dos nodes padronizados em grafite monocromático (sem cor por tipo) —
// dá "cara de sistema", não de template de IA. Theme-aware, com bom contraste
// tanto no claro quanto no escuro. O `color` de cada item em SIDEBAR_CATEGORIES
// segue existindo (compat), mas os ícones não o usam mais.
var NODE_ICON_COLOR = function (isDark) { return isDark ? "#e5e7eb" : "#374151"; };
var NODE_ICON_CHIP = function (isDark) {
  return isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.05)";
};

export {
  SIDEBAR_CATEGORIES,
  TOOL_TYPES,
  NODE_TYPES_CONFIG,
  TRIGGER_TYPES,
  TOOL_ITEMS,
  DEFAULT_NODES,
  NODE_ICON_COLOR,
  NODE_ICON_CHIP,
};
